import React, { useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { formatMoney } from 'accounting';

export type ProductButtonProps = {
  id: number;
  title: string;
  price: string;
  isSelected: boolean;
  onClick: React.MouseEventHandler;
  imageUrl: string;
  hasTooltip: boolean;
  onClickTooltip: (id: string) => void;
};

function ProductButton({
  title,
  id,
  price,
  isSelected,
  onClick,
  hasTooltip,
  imageUrl,
  onClickTooltip,
}: ProductButtonProps) {
  const productButtonId = `product-button-${id}`;

  return (
    <div className="product-button-container">
      <button
        id={productButtonId}
        className={`product-button ${isSelected ? 'selected' : ''}`}
        onClick={onClick}
      >
        {imageUrl !== '' && <img src={imageUrl} alt={title} />}
        {title !== '' && <span dangerouslySetInnerHTML={{ __html: title }} />}
        {parseFloat(price) > 0 && <span className="price">{formatMoney(price)}</span>}
      </button>
      {hasTooltip && (
        <button className="tooltip-button" onClick={() => onClickTooltip(productButtonId)}>
          <FontAwesomeIcon icon="info-circle" />
          <span className="screen-reader-text">Learn More</span>
        </button>
      )}
    </div>
  );
}

export default ProductButton;
